import Api from "../../../util/Api";

export default function getInitState() {
    return {
        myReservationsAdditionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        myReservationsRowActions: [
            {
                btn_text: '<i class="fas fa-file-medical-alt"></i>',
                title: 'Adatlap megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'showPatientBasicDataSheet'
            }
        ],
        myReservationsActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        myReservationsSearchFields: [
            {
                label: "Időponttól",
                name: 'appointmentFrom',
                formRequired: true,
                formSize: 4,
                formType: 'dateTime'
            },
            {
                label: "Időpontig",
                name: 'appointmentTo',
                formRequired: true,
                formSize: 4,
                formType: 'dateTime'
            },
            {
                name: "companySiteId",
                label: "Telephely",
                description: "Amennyiben nincs kiválasztva telephely, minden telephelyre vonatkozik a keresés",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            }
        ],
        myReservationsTableHeaderFields: [
            {
                label: "Időpont",
                name: "appointment",
                slot_name: "appointment_format"
            },
            {
                label: "Név",
                name: "patient.name",
                slot_name: "patientNameFormat"
            },
            {
                label: "Telefonszám",
                name: "patient.phoneNumber"
            },
            {
                label: "TAJ",
                name: "patient.socialInsuranceNumber"
            },
            {
                label: "Telephely",
                name: "companySite.siteName"
            },
            {
                label: "Szoba",
                name: "room.name"
            },
            {
                label: "Kezelés",
                name: "treatment.title"
            },
            {
                label: "Állapot",
                name: "appointmentStatus.text"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
